import React from "react";
import { connect } from "react-redux";
import { FullPageLoader } from "@authzsvc/common-react-components";
import LoadedApp from "./LoadedApp";
import PropTypes from "prop-types";

const App = ({ ready }) => {
  if (ready) {
    return <LoadedApp />;
  } else {
    return <FullPageLoader />;
  }
};

App.propTypes = {
  ready: PropTypes.bool.isRequired,
};

export default connect((state) => ({
  ready: state.keycloak.ready && state.keycloak.authenticated,
}))(App);
